export default "__VITE_ASSET__DR24feM6__"